/* Al Ubaid Motors Toyota MSRP update data. Upload this file to Shopify Assets as aum-toyota-msrp-updates.js */
(function(){
  const AUM_ROWS = window.AUM_ROWS = window.AUM_ROWS || [];

  function aumClean(value){
    return String(value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  }

  function aumSlug(value){
    return String(value || "").toUpperCase().replace(/[^A-Z0-9]+/g,"-").replace(/^-+|-+$/g,"").replace(/-+/g,"-");
  }

  function aumIsLandCruiser250Row(row){
    const chassis = aumClean(row && row.chassis);
    if(chassis.indexOf("TRJ250W") !== -1 || chassis.indexOf("GDJ250W") !== -1) return true;
    const text = [
      row && row.make,
      row && row.model,
      row && row.name,
      row && row.variant,
      row && row.variantLabel,
      row && row.method,
      row && row.status,
      row && row.row
    ].join(" ").toUpperCase();
    return text.indexOf("TOYOTA") !== -1 && (
      text.indexOf("LAND CRUISER 250") !== -1 ||
      text.indexOf("LANDCRUISER250") !== -1 ||
      text.indexOf("LC250") !== -1
    );
  }

  // Replace old/incomplete Land Cruiser 250 rows with the latest user-provided MSRP rows.
  const keptRows = AUM_ROWS.filter(function(row){ return !aumIsLandCruiser250Row(row); });
  AUM_ROWS.length = 0;
  keptRows.forEach(function(row){ AUM_ROWS.push(row); });

  const AUM_TOYOTA_LC250_PACKED = `04/2026|VX|3BA-TRJ250W|2693|5|7|SUV|PETROL|6AT|2026|5779400|2240|4925mm × 1980mm × 1925mm
04/2024|VX|3BA-TRJ250W|2693|5|7|SUV|PETROL|6AT|2024|5450000|2240|4925mm × 1980mm × 1925mm
04/2024|VX FIRST EDITION LIMITED MODEL|3BA-TRJ250W|2693|5|7|SUV|PETROL|6AT|2024|5900000|2240|4925mm × 1980mm × 1925mm
04/2024|GX|3DA-GDJ250W|2754|5|5|SUV|DIESEL|8AT|2024|5200000|2320|4925mm × 1940mm × 1925mm
04/2024|VX|3DA-GDJ250W|2754|5|7|SUV|DIESEL|8AT|2024|6300000|2380|4925mm × 1980mm × 1925mm
04/2024|VX FIRST EDITION LIMITED MODEL|3DA-GDJ250W|2754|5|7|SUV|DIESEL|8AT|2024|7000000|2390|4925mm × 1980mm × 1925mm
04/2024|ZX|3DA-GDJ250W|2754|5|7|SUV|DIESEL|8AT|2024|7350000|2410|4925mm × 1980mm × 1935mm
04/2024|ZX FIRST EDITION LIMITED MODEL|3DA-GDJ250W|2754|5|7|SUV|DIESEL|8AT|2024|7850000|2400|4925mm × 1980mm × 1935mm`;

  AUM_TOYOTA_LC250_PACKED.trim().split(/\n+/).forEach(function(line){
    const p = line.split("|");
    const sale = p[0] || "";
    const variantRaw = p[1] || "";
    const limited = /\bLIMITED MODEL\b/i.test(variantRaw);
    const variantClean = variantRaw.replace(/\s*LIMITED MODEL\s*$/i, "").trim();
    const chassis = p[2] || "";
    const cc = Number(p[3] || 0);
    const doors = Number(p[4] || 0);
    const seats = Number(p[5] || 0);
    const type = p[6] || "SUV";
    const fuel = p[7] || "PETROL";
    const drive = p[8] || "";
    const year = Number(p[9] || 0);
    const msrp = Number(p[10] || 0);
    const weightKg = Number(p[11] || 0);
    const dimensions = p[12] || "";
    const rowId = "TOYOTA-LC250-" + aumSlug(chassis) + "-" + aumSlug(variantClean) + "-" + aumSlug(sale) + "-" + msrp;
    const row = {
      row: rowId,
      chassis: chassis,
      make: "TOYOTA",
      model: "LAND CRUISER 250",
      name: "TOYOTA LAND CRUISER 250",
      variant: variantClean,
      variantLabel: variantClean + (limited ? " · Limited Model" : "") + " · Sale " + sale,
      type: type,
      fuel: fuel,
      year: year,
      cc: cc,
      doors: doors,
      seats: seats,
      drive: drive,
      cur: "JPY",
      msrp: msrp,
      method: "TOYOTA LAND CRUISER 250 MSRP",
      status: "Manual MSRP · TOYOTA LAND CRUISER 250 · Sale " + sale + " · User provided"
    };
    if(weightKg) row.weightKg = weightKg;
    if(dimensions) row.dimensions = dimensions;
    AUM_ROWS.push(row);
  });
})();
